import styled from "styled-components";

const TextField = styled.input`
  width: 100%;
  background-color: transparent;
  border: none;
  outline: none;
  font-size: 17px;
`;

export default TextField;
